export const Card = ({ children, style }) => (
  <div className="card" style={style}>
    {children}
  </div>
);
